export const config = {
  // BASE_API: "http://localhost:8000/",
  BASE_API: "https://api.o1codingclub.in/",
};
